import {
  store,
  clearDeliveryInfo,
  clearOrderTableNumber,
  deleteAllOrderItems,
  deleteOrderForEditDetails
} from "@redux"

const clearCart = () => {
  store.dispatch(clearDeliveryInfo())

  store.dispatch(deleteAllOrderItems())

  store.dispatch(
    deleteOrderForEditDetails()
  )

  store.dispatch(
    clearOrderTableNumber()
  )
}

export default clearCart